/* eslint-disable */
import './App.css';
import 'tiny-slider/dist/tiny-slider.css';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Contact from './components/Contact';
import About from './pages/About';
import './i18n/i18n';
import CookiePolicy from './cookie/CookiePolicy';
import ScrolltoTop from '../src/components/ScrolltoTop'
import { Toaster } from 'react-hot-toast';




function App() {

  return (
    <>

<Toaster
  position="top-center" 
  gutter={0} 
  toastOptions={{
    icon: null,
    duration: 4000,
    style: {
     
      background: '#1f1f2c',
      color: '#dcbc5c',
      


      fontSize: '11px',
      fontWeight: '600',
      letterSpacing: '0.3em', 
      textTransform: 'uppercase',
      
   
      borderRadius: '0px', 
      padding: '24px 60px',
      minWidth: '80px',
      
      // İnce Detaylar
      borderBottom: '1px solid #dcbc5c', // Sadece altta çok ince bir altın çizgi
      boxShadow: '0 10px 40px rgba(0,0,0,0.6)',
      
      margin: '0',
      textAlign: 'center',
    },
      }} />
      <BrowserRouter>
        <CookiePolicy />
        <ScrolltoTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path='*' element={<div>404</div>} />


        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
